import { useContext, useMemo } from 'react';
import { TrackerPropsContext } from '../provider/TrackerPropsProvider';
import { useContentObjectType } from 'content-management-data-lib';
const useTrackerProps = () => {
  const trackerProps = useContext(TrackerPropsContext);
  const {
    contentObjectType
  } = useContentObjectType();
  if (trackerProps === undefined) {
    throw new Error('useTrackerProps must be used within a TrackerPropsProvider');
  }
  return useMemo(() => ({
    tableTrackerProps: trackerProps,
    actionsTrackerProps: {
      applicationId: trackerProps.applicationId,
      onTrackEvent: trackerProps.onTrackEvent,
      objectTypeId: contentObjectType
    }
  }), [trackerProps, contentObjectType]);
};
export default useTrackerProps;